import React, { useState } from "react";
import { useForm } from "react-hook-form";
import * as Icons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { themes, optionalAvathar } from "services/constants";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { BackArrow } from "components/CustomComponents/BackArrow";
import { useFetch } from "services/hooks/useFetch";
import { customGetAPI, customAPI } from "services/utils/CustomAPI";
import { formKeyText, tooltipStyleProps } from "services/constants/Styles";
let multiApiCallRestriction = true;

export const AddDepartment = ({ setOpen, setDepartmentApi }) => {
  const { domain, userDetails } = useSelector((state) => state.tokenReducer);
  const [departmentLeadName, setDepartmentLeadName] = useState("");
  const [departmentProxyName, setDepartmentProxyName] = useState("");
  const [departmentProxyList, setDepartmentProxyList] = useState([]);
  const [workUnit, setWorkUnit] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const { result: departmentLeadList } = useFetch(`${domain}all-members/`);
  const {
    setValue,
    handleSubmit,
    reset,
    register,
    watch,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const onSubmit = async (data) => {
    setButtonLoader(true);
    if (multiApiCallRestriction) {
      multiApiCallRestriction = false;
      const response = await customAPI(`${domain}create_department/`, "POST", {
        department_lead_id: data.departmentLeadId,
        departmentname: data.department.trim(),
        proxy_id: data.departmentProxy,
        approved_by: userDetails.username,
        work_unit: workUnit,
      });
      if (response.ok) {
        reset();
        setDepartmentApi(true);
        showToast("success", "Department created successfully");
        setOpen(false);
        setButtonLoader(false);
        multiApiCallRestriction = true;
      } else {
        setButtonLoader(false);
        multiApiCallRestriction = true;
      }
    }
  };
  const checkSpecialChar = (e) => {
    if (!/^[a-zA-Z0-9 ]*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const getDepartmentProxyList = (leadName) => {
    if (leadName !== "") {
      setDepartmentProxyList(departmentLeadList);
    } else {
      setDepartmentProxyList([]);
    }
  };

  const hadleWorkUnit = (event) => {
    setWorkUnit(event.target.checked);
  };

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 1 }}>
        <BackArrow actionFunction={() => setOpen(false)} />
        <Mui.Typography
          sx={{ fontWeight: "bold", fontSize: 25, paddingTop: 1 }}
        >
          Departments / Add Department
        </Mui.Typography>
      </Mui.Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Mui.Grid container sx={{ paddingTop: 2 }}>
          <Mui.Grid xs={12} sm={12} md={3} lg={2.5}></Mui.Grid>

          <Mui.Grid xs={12} sm={12} md={6} lg={7.5} sx={{ paddingTop: 10 }}>
            <Mui.Grid container component={Mui.Paper}>
              <Mui.Grid
                xs={12}
                sx={{
                  padding: 1,
                  backgroundColor: themes.primary,
                  borderRadius: "10px 10px 0 0",
                  border: `2px solid ${themes.sidebarDivider}`,
                  borderBottom: "none",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Mui.Typography
                  sx={{ fontSize: 24, fontWeight: 800, font: "bold" }}
                >
                  Add Department
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Stack
              sx={{
                paddingTop: 1,
                padding: 5,
                borderRadius: "0 0 10px 10px",
                border: `2px solid ${themes.sidebarDivider}`,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Mui.Grid container>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formKeyText}>
                    Department name&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        "Enter a unique and recognizable name for the department.This helps in organizing employees and tasks by department."
                      }
                    >
                      <Icons.Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={8}>
                  <Mui.TextField
                    size="small"
                    placeholder="Enter department name"
                    sx={{
                      borderWidth: "10px solid black",
                      paddingBottom: 2,
                    }}
                    {...register("department", {
                      required: "Department is required",
                      maxLength: {
                        value: 30,
                        message: "Maximum length is 30 characters",
                      },
                      validate: {
                        noDigitsOrSpecial: (fieldValue) => {
                          if (!/[A-Za-z]/.test(fieldValue)) {
                            return "Department Name must contain at least one alphabet character.";
                          }
                          if (/^\d+$/.test(fieldValue)) {
                            return "Department Name should not contain only digits.";
                          }
                          if (!/^[A-Za-z0-9\s&-]+$/.test(fieldValue)) {
                            return "Department name should only contain alphabets, spaces, -,numbers and & symbol.";
                          }
                          return true;
                        },
                        checkUnique: async (fieldValue) => {
                          if (fieldValue !== "" && !buttonLoader) {
                            const res = await customGetAPI(
                              `${domain}check_department_name/?department_name=${fieldValue.trim()}`
                            );
                            if (res.ok) {
                              if (res?.responseDetails?.exists) {
                                return "The department name has been already taken.Use a unique department name to proceed further";
                              } else {
                                return true;
                              }
                            }
                          }
                        },
                      },
                    })}
                    error={Boolean(errors.department)}
                    helperText={errors.department?.message || ""}
                    onKeyPress={checkSpecialChar}
                    InputProps={{
                      startAdornment: (
                        <Mui.InputAdornment>
                          <Icons.AddBusiness
                            style={{
                              color: "#a6a6a6",
                            }}
                          />
                          &nbsp;
                        </Mui.InputAdornment>
                      ),
                    }}
                    fullWidth
                  />
                </Mui.Grid>
              </Mui.Grid>

              <Mui.Grid container>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formKeyText}>
                    Is workunit applicable ?&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        "Toggle this switch ON if the department will operate with work units (task-based or unit-based tracking).Keep it OFF if work units are not relevant for this department."
                      }
                    >
                      <Icons.Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={8}>
                  <Mui.Switch
                    onChange={hadleWorkUnit}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formKeyText}>
                    Department Lead&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        "Select the person responsible for managing and supervising the department.This lead will have authority over departmental activities and employee management."
                      }
                    >
                      <Icons.Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={8}>
                  <Mui.Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    size="small"
                    value={departmentLeadName}
                    options={departmentLeadList.map((obj) => ({
                      ...obj,
                      label: obj.username,
                    }))}
                    sx={{ width: "100%" }}
                    ListboxProps={{ style: { maxHeight: "150px" } }}
                    filterOptions={(options, state) => {
                      return options.filter((option) =>
                        option.label
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      );
                    }}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <img
                          src={option.image_url ?? optionalAvathar}
                          alt={option.label}
                          style={{
                            width: 25,
                            height: 25,
                            marginRight: 5,
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, value) => {
                      if (value) {
                        setDepartmentLeadName(value.username);
                        setValue("departmentLeadId", value.id);
                        getDepartmentProxyList(value.username);
                      } else {
                        setValue("departmentLeadId", null);
                        setDepartmentLeadName("");
                        getDepartmentProxyList("");
                      }
                    }}
                    renderInput={(params) => (
                      <Mui.TextField
                        size="small"
                        {...params}
                        value={departmentLeadName}
                        {...register("departmentLead", {
                          required: "Department lead is required",
                        })}
                        sx={{
                          background: themes.whiteColor,
                          paddingBottom: 2,
                        }}
                        placeholder="Select department lead"
                        error={Boolean(errors.departmentLead)}
                        helperText={errors.departmentLead?.message || ""}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              {departmentLeadName && (
                                <img
                                  src={
                                    departmentLeadList.find(
                                      (u) => u?.id === watch("departmentLeadId")
                                    )?.image_url ?? optionalAvathar
                                  }
                                  alt="avatar"
                                  style={{
                                    width: 25,
                                    height: 25,
                                    borderRadius: "50%",
                                    marginRight: 1,
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        fullWidth
                      />
                    )}
                  />
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid container>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formKeyText}>
                    Proxy&nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        "Select an alternate responsible person (proxy) to act on behalf of the department lead when unavailable.Useful for approval flows and temporary leadership needs."
                      }
                    >
                      <Icons.Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={8}>
                  <Mui.Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    size="small"
                    value={departmentProxyName}
                    options={departmentProxyList.map((obj) => ({
                      ...obj,
                      label: obj.username,
                    }))}
                    sx={{ width: "100%", paddingBottom: 2 }}
                    ListboxProps={{ style: { maxHeight: "150px" } }}
                    filterOptions={(options, state) => {
                      return options.filter((option) =>
                        option.label
                          .toLowerCase()
                          .includes(state.inputValue.toLowerCase())
                      );
                    }}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <img
                          src={option.image_url ?? optionalAvathar}
                          alt={option.label}
                          style={{
                            width: 25,
                            height: 25,
                            marginRight: 5,
                            borderRadius: "50%",
                            objectFit: "cover",
                          }}
                        />
                        {option.label}
                      </li>
                    )}
                    onChange={(event, value) => {
                      if (value) {
                        setDepartmentProxyName(value.username);
                        setValue("departmentProxy", value.id);
                      } else {
                        setValue("departmentProxy", null);
                        setDepartmentProxyName("");
                      }
                    }}
                    renderInput={(params) => (
                      <Mui.TextField
                        {...params}
                        value={departmentProxyName}
                        {...register("proxyName", {
                          required: "Proxy name is required",
                        })}
                        sx={{
                          background: themes.whiteColor,
                        }}
                        placeholder="Select proxy name"
                        size="small"
                        error={Boolean(errors.proxyName)}
                        helperText={errors.proxyName?.message || ""}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <>
                              {departmentProxyName && (
                                <img
                                  src={
                                    departmentProxyList.find(
                                      (u) => u?.id === watch("departmentProxy")
                                    )?.image_url ?? optionalAvathar
                                  }
                                  alt="avatar"
                                  style={{
                                    width: 25,
                                    height: 25,
                                    borderRadius: "50%",
                                    marginRight: 1,
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                              {params.InputProps.startAdornment}
                            </>
                          ),
                        }}
                        fullWidth
                      />
                    )}
                  />
                </Mui.Grid>
              </Mui.Grid>
              <Mui.Grid
                container
                sx={{ justifyContent: "right", paddingBottom: 2 }}
              >
                <CustomButton
                  key={buttonLoader}
                  actionName="Create"
                  typeName="submit"
                  disableAction={buttonLoader}
                />
              </Mui.Grid>
            </Mui.Stack>
          </Mui.Grid>
          <Mui.Grid xs={12} sm={12} md={3} lg={2}></Mui.Grid>
        </Mui.Grid>
      </form>
    </React.Fragment>
  );
};
